import { useState, useEffect, useReducer, useContext } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { isNill } from "lodash";

const reducer = (state, action) => {
  if (action.type === "LOAD_WHATSAPPS") {
    const whatsApps = action.payload;
    if (!Array.isArray(whatsApps)) {
      return state;
    }
    return whatsApps.filter(w => w != null);
  }

  if (action.type === "UPDATE_WHATSAPPS") {
    const whatsApp = action.payload;
    if (whatsApp == null || whatsApp.id == null) {
      return state;
    }
    
    const cleanState = (state || []).filter(s => s != null && s.id != null);
    const whatsAppIndex = cleanState.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      cleanState[whatsAppIndex] = whatsApp;
      return [...cleanState];
    } else {
      return [whatsApp, ...cleanState];
    }
  }

  if (action.type === "UPDATE_SESSION") {
    const whatsApp = action.payload;
    if (whatsApp == null || whatsApp.id == null) {
      return state;
    }

    const cleanState = (state || []).filter(s => s != null && s.id != null);
    const whatsAppIndex = cleanState.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      const updatedWhatsApp = {
        ...cleanState[whatsAppIndex],
        status: whatsApp.status,
        updated_at: whatsApp.updated_at,
        qrcode: whatsApp.qrcode,
        retries: whatsApp.retries
      };
      cleanState[whatsAppIndex] = updatedWhatsApp;
      return [...cleanState];
    } else {
      return [...cleanState];
    }
  }

  if (action.type === "DELETE_WHATSAPPS") {
    const whatsAppId = action.payload;
    if (whatsAppId == null) {
      return state;
    }

    const cleanState = (state || []).filter(s => s != null && s.id != null);
    const whatsAppIndex = cleanState.findIndex((s) => String(s.id) === String(whatsAppId));
    if (whatsAppIndex !== -1) {
      cleanState.splice(whatsAppIndex, 1);
    }
    return [...cleanState];
  }

  if (action.type === "RESET") {
    return [];
  }

  return state;
};

const useWhatsApps = () => {
  const [whatsApps, dispatch] = useReducer(reducer, []);
  const [loading, setLoading] = useState(true);
//   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);



  useEffect(() => {
    let isMounted = true;

    if (!user.id) return;
    setLoading(true);
    const fetchSession = async () => {
      try {
        if (!localStorage.getItem("token")) {
          if (isMounted) {
            setLoading(false);
          }
          return;
        }
        const { data } = await api.get("/whatsapp/?session=0");
        if (!isMounted) return;
        dispatch({ type: "LOAD_WHATSAPPS", payload: data });
        setLoading(false);
      } catch (err) {
        if (!isMounted) return;
        console.error("Error fetching whatsapps", err);
        setLoading(false);
        // toastError(err);
      }
    };
    fetchSession();

    return () => {
      isMounted = false;
    };
  }, [user.id]);

  useEffect(() => {
    if (user.company_id && socket) {

      const company_id = user.company_id;
//    const socket = socketManager.GetSocket();

      const onCompanyWhatsapp = (data) => {
        if (data.action === "update") {
          dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
        }
        if (data.action === "delete") {
          dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsapp_id });
        }
      }

      const onCompanyWhatsappSession = (data) => {
        if (data.action === "update") {
          dispatch({ type: "UPDATE_SESSION", payload: data.session });
        }
      }

      socket.on(`company-${company_id}-whatsapp`, onCompanyWhatsapp);
      socket.on(`company-${company_id}-whatsappSession`, onCompanyWhatsappSession);

      return () => {
        socket.off(`company-${company_id}-whatsapp`, onCompanyWhatsapp);
        socket.off(`company-${company_id}-whatsappSession`, onCompanyWhatsappSession);
      };
    }
  }, [socket, user.company_id]);

  return { whatsApps, loading, dispatch };
};

export default useWhatsApps;
